import React, { useEffect } from "react";
import { Box, Button, Image, Link, Text } from "@chakra-ui/react";
import notFound from '../../assets/svgs/notFound.svg'

export default function NotFound() {
  useEffect(() => {
    document.title = "Not Found";
  }, []);
  
  return (
    <React.Fragment>
      <Box w='90%' maxW={['85rem', '85rem', '85rem', '85rem', '85rem', '90rem']} mx='auto'>
        <Box mt={100}>
          <Box w='15rem' h='15rem' mx='auto'>
            <Image src={notFound} />
          </Box>

          <Box textAlign='center'>
            <Text 
              fontWeight='bold' 
              fontSize='xl' 
              color='#4A5568'
            >
              LOOKS LIKE YOU'RE LOST
            </Text>

            <Text 
              mt={5}
              fontWeight='light'
              fontSize='md'
              color='#3d3b3b' 
            >
              The page that you are looking for is not available
            </Text>
          </Box>

          <Box mt={5} textAlign='center'>
            <Link href="/dashboard">
              <Button
                type="button"
                bg="#056424"
                _hover={{ bg: "#04541f", transition: "background-color 0.75s linear" }}
                rounded="md"
                boxShadow="md"
                color="white"
                px={6}
                py={2}
              >
                Back to dashboard
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  )
}